import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    comprasImpuestos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    impuesto: null,
    sortByDescending: false,

    compraImpuestoDatos: [],
    compraImpuestoCuentasDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.comprasImpuestos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.impuesto = null;
        state.sortByDescending = false;
    },

    'INICIALIZAR_COMPRAS_IMPUESTOS' (state) {
        state.comprasImpuestos = [];
    },
    'SET_COMPRAS_IMPUESTOS' (state, comprasImpuestos) {
        state.comprasImpuestos = comprasImpuestos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_DATOS' (state) {
        state.compraImpuestoDatos = [];
        state.compraImpuestoCuentasDatos = [];
    },
    'SET_COMPRA_DATOS' (state, params) {
        state.compraImpuestoDatos = params.compraImpuestoDatos;
        state.compraImpuestoCuentasDatos = params.compraImpuestoCuentasDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getComprasImpuestos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COMPRAS_IMPUESTOS');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.impuesto) {
                if (state.impuesto.id != 0) {
                    queryString += '&proveedorId=' + state.impuesto.id;
                }
            }
            
            apiAxios.get('impuestos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_COMPRAS_IMPUESTOS', res.data);

                    resolve();
                })
                .catch(error =>  {
                    reject(error);
                })
        })            
    },
    delete ( {}, compraImpuestoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('impuestos/' + compraImpuestoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getDatos ( { commit }, compraImpuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (compraImpuestoId) {
                apiAxios.get('impuestos/' + compraImpuestoId ) 
                    .then(res => {
                        let formatoPeriodo = 'periodo';
                        if (res.data.impuestoPresentacionAnual) {
                            formatoPeriodo = 'periodoAnual';
                        }

                        let compraImpuestoDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'impuestoOrganismo', 'campo': 'Organismo', 'valor': res.data.impuestoOrganismo, 'formato': '' },
                            { 'nombre': 'impuesto', 'campo': 'Impuesto', 'valor': res.data.impuesto, 'formato': '' },
                            { 'nombre': 'periodo', 'campo': 'Periodo', 'valor': res.data.periodo, 'formato': formatoPeriodo },
                            { 'nombre': 'montoTotal', 'campo': 'Importe', 'valor': res.data.montoTotal, 'formato': 'moneda' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        ]

                        let params = {
                            compraImpuestoDatos,
                            compraImpuestoCuentasDatos: res.data.cuentas,
                        }
                                      
                        commit('SET_COMPRA_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}